import React from "react";
import { Monitor } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

/**
 * No BrowserView do DeliDesk não mostramos o login CNPJ do site.
 * A sessão do painel vem do OAuth "Entrar com DelivAI" no app.
 */
export const DelideskEmbedSessionGate: React.FC = () => {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-gradient-delivai flex items-center justify-center px-4 text-white">
      <div
        className="w-full max-w-md rounded-2xl border border-white/15 bg-white/10 backdrop-blur-md p-8 text-center shadow-xl"
        role="status"
      >
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl border border-[#47F2C7]/40 bg-[#47F2C7]/15">
          <Monitor className="h-7 w-7 text-[#47F2C7]" aria-hidden />
        </div>
        <h1 className="mb-2 text-xl font-bold">{t("delidesk.embed.gate_title")}</h1>
        <p className="text-sm text-white/75">{t("delidesk.embed.gate_body")}</p>
        <p className="mt-4 text-xs text-white/45">{t("delidesk.embed.gate_hint")}</p>
      </div>
    </div>
  );
};
